'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginPopup = function (_React$Component) {
  (0, _inherits3.default)(LoginPopup, _React$Component);

  function LoginPopup() {
    (0, _classCallCheck3.default)(this, LoginPopup);
    return (0, _possibleConstructorReturn3.default)(this, (LoginPopup.__proto__ || (0, _getPrototypeOf2.default)(LoginPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginPopup, [{
    key: 'onLogin',
    value: function onLogin() {
      var closePopup = this.props.closePopup;


      closePopup();
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./LoginPopup.scss');

      console.log('LoginBox:', this.onLogin.bind(this));

      return _react2.default.createElement(
        'div',
        { className: styles.LoginPopup },
        _react2.default.createElement(_components.LoginBox, { onLogin: this.onLogin.bind(this) })
      );
    }
  }]);
  return LoginPopup;
}(_react2.default.Component);

exports.default = LoginPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginPopup/LoginPopup.jsx
// module id = 2638
// module chunks = 0